import { Button, Col, Modal, Row } from 'antd';
import { Footer } from 'antd/lib/layout/layout';
import React, { useRef } from 'react';
import Header from '../../common/compornents/layout/header/Header';
import JuchuShokai, { IHandles } from './JuchuShokaiMain';

interface IProps {
  visibleState: boolean;
  CloseJuchuShokaiModal: () => void;
}
const JuchuShokaiModal: React.FC<IProps> = (props: IProps) => {
  const closeModalRef = useRef<IHandles>(null);
  const closeModal = () => {
    closeModalRef.current?.clickClear();
    props.CloseJuchuShokaiModal();
  };

  return (
    <Modal closable={false} width={1500} visible={props.visibleState} footer={null} className="shokai">
      <Header screenName={'注文一覧'} />
      <JuchuShokai
        yobidashimotoKbn="2"
        CloseJuchuShokaiModal={props.CloseJuchuShokaiModal}
        ref={closeModalRef}
      ></JuchuShokai>
      <Footer
        style={{
          backgroundColor: '#e6f7ff',
          height: '70px',
        }}
      >
        <Row>
          <Col offset={22}>
            <Button size={'large'} type="primary" onClick={closeModal}>
              戻る
            </Button>
          </Col>
        </Row>
      </Footer>
    </Modal>
  );
};

export default JuchuShokaiModal;
